module.exports = __webpack_public_path__ + "static/img/yj3.d065981b.png";